import Immutable from "immutable";

const initialState = {
    loadingApplications: false,
    loadingApplicationsFailed: false,
    loadingApplicationsError: "",
    creatingApplication: false,
    creatingApplicationFailed: false,
    creatingApplicationError: "",
    sendingApplication: false,
    sendingApplicationFailed: false,
    sendingApplicationError: "",
    revertingApplication: false,
    revertingApplicationFailed: false,
    revertingApplicationError: "",

    applications: [],
    contestId: -1,
    applicationId: -1,

    loadingApplication: false,
    loadingApplicationFailed: false,
    loadingApplicationError: "",
    savingPresentation: false,
    savingPresentationFailed: false,
    savingPresentationError: "",
    deletingPresentation: false,
    deletingCategoryId: -1,
    deletingPresentationId: -1,
    deletingPresentationFailed: false,
    deletingPresentationError: "",

    application: {},
    contest: {},
    categories: [],
    participants: [],

    category: {},
    presentation: {},

    presentationNameErrors: [],
    presentationParticipantsErrors: [],

    participantSearchText: "",
    availableParticipants: [],

    soloParticipants: [],

    loadingPayments: false,
    loadingPaymentsFailed: false,
    loadingPaymentsError: "",
    payments: [],
    totalCost: 0,
};

export default function reducer(state = initialState, action) {
    var participants = [];
    var categories = [];
    switch (action.type) {
        case "GET_APPLICATIONS_PENDING":
            return Immutable.fromJS(state).set("loadingApplications", true).set("loadingApplicationsFailed", false).set("loadingApplicationsError", "").set("applications", []).toJS();
        case "GET_APPLICATIONS_FULFILLED":
            return Immutable.fromJS(state).set("loadingApplications", false).set("applications", action.payload.data).toJS();
        case "GET_APPLICATIONS_REJECTED":
            return Immutable.fromJS(state).set("loadingApplications", false).set("loadingApplicationsFailed", true).set("loadingApplicationsError", action.payload.response.data.message).toJS();
        case "CREATE_APPLICATION_PENDING":
            return Immutable.fromJS(state)
                .set("creatingApplication", true)
                .set("creatingApplicationFailed", false)
                .set("creatingApplicationError", "")
                .set("contestId", action.meta.application.contest.id)
                .toJS();
        case "CREATE_APPLICATION_FULFILLED":
            return Immutable.fromJS(state)
                .set("creatingApplication", false)
                .set(
                    "applications",
                    state.applications.map((app) => (app.contest.id === state.contestId ? action.payload.data : app))
                )
                .set("contestId", -1)
                .toJS();
        case "CREATE_APPLICATION_REJECTED":
            return Immutable.fromJS(state)
                .set("creatingApplication", false)
                .set("creatingApplicationFailed", true)
                .set("creatingApplicationError", action.payload.response.data.message)
                .set("contestId", -1)
                .toJS();
        case "SEND_APPLICATION_PENDING":
            return Immutable.fromJS(state)
                .set("sendingApplication", true)
                .set("sendingApplicationFailed", false)
                .set("sendingApplicationError", "")
                .set("applicationId", action.meta.application.id)
                .toJS();
        case "SEND_APPLICATION_FULFILLED":
            return Immutable.fromJS(state)
                .set("sendingApplication", false)
                .set("applicationId", -1)
                .set(
                    "applications",
                    state.applications.map((app) => (app.id === state.applicationId ? Immutable.fromJS(app).set("status", "SENT").toJS() : app))
                )
                .set("application", Immutable.fromJS(state.application).set("status", "SENT").toJS())
                .toJS();
        case "SEND_APPLICATION_REJECTED":
            return Immutable.fromJS(state)
                .set("sendingApplication", false)
                .set("sendingApplicationFailed", true)
                .set("sendingApplicationError", action.payload.response.data.message)
                .set("applicationId", -1)
                .toJS();
        case "REVERT_APPLICATION_PENDING":
            return Immutable.fromJS(state)
                .set("revertingApplication", true)
                .set("revertingApplicationFailed", false)
                .set("revertingApplicationError", "")
                .set("applicationId", action.meta.application.id)
                .toJS();
        case "REVERT_APPLICATION_FULFILLED":
            return Immutable.fromJS(state)
                .set("revertingApplication", false)
                .set("applicationId", -1)
                .set(
                    "applications",
                    state.applications.map((app) => (app.id === state.applicationId ? Immutable.fromJS(app).set("status", "DRAFT").toJS() : app))
                )
                .set("application", Immutable.fromJS(state.application).set("status", "DRAFT").toJS())
                .toJS();
        case "REVERT_APPLICATION_REJECTED":
            return Immutable.fromJS(state)
                .set("revertingApplication", false)
                .set("revertingApplicationFailed", true)
                .set("revertingApplicationError", action.payload.response.data.message)
                .set("applicationId", -1)
                .toJS();
        case "DELETE_APPLICATION_PENDING":
            return Immutable.fromJS(state)
                .set("deletingApplication", true)
                .set("deletingApplicationFailed", false)
                .set("deletingApplicationError", "")
                .set("contestId", action.meta.application.contest.id)
                .set("applicationId", action.meta.application.id)
                .toJS();
        case "DELETE_APPLICATION_FULFILLED":
            return Immutable.fromJS(state)
                .set("deletingApplication", false)
                .set(
                    "applications",
                    state.applications.map((app) => (app.id === state.applicationId ? { contest: app.contest } : app))
                )
                .set("contestId", -1)
                .set("applicationId", -1)
                .toJS();
        case "DELETE_APPLICATION_REJECTED":
            return Immutable.fromJS(state)
                .set("deletingApplication", false)
                .set("deletingApplicationFailed", true)
                .set("deletingApplicationError", action.payload.response.data.message)
                .set("contestId", -1)
                .set("applicationId", -1)
                .toJS();
        case "GET_APPLICATION_PENDING":
            return Immutable.fromJS(state)
                .set("loadingApplication", true)
                .set("loadingApplicationFailed", false)
                .set("loadingApplicationError", "")
                .set("application", {})
                .set("contest", {})
                .set("categories", [])
                .set("participants", [])
                .toJS();
        case "GET_APPLICATION_FULFILLED":
            return Immutable.fromJS(state)
                .set("loadingApplication", false)
                .set("application", {
                    id: action.payload.data.id,
                    uuid: action.payload.data.uuid,
                    status: action.payload.data.status,
                    categoryCount: countUsedCategories(action.payload.data.categories),
                    presentationCount: countPresentations(action.payload.data.categories),
                    participantCount: countParticipants(action.payload.data.categories),
                    totalCost: calculateTotalCost(action.payload.data.categories, action.payload.data.contest),
                })
                .set("contest", action.payload.data.contest)
                .set("categories", action.payload.data.categories)
                .set("participants", action.payload.data.participants)
                .toJS();
        case "GET_APPLICATION_REJECTED":
            return Immutable.fromJS(state).set("loadingApplication", false).set("loadingApplicationFailed", true).set("loadingApplicationError", action.payload.response.data.message).toJS();
        case "EDIT_SOLO_CATEGORY":
            participants = action.category.presentations.map((p) => p.participants[0]);
            return Immutable.fromJS(state)
                .set("category", action.category)
                .set("soloParticipants", participants)
                .set("participantSearchText", "")
                .set("availableParticipants", getAvailableParticipants(state.participants, action.category, participants, ""))
                .toJS();
        case "ADD_PRESENTATION":
            return Immutable.fromJS(state)
                .set("category", Immutable.fromJS(action.category).set("presentations", action.category.presentations.concat(action.presentation)).toJS())
                .set("presentation", action.presentation)
                .set("presentationNameErrors", isDuet(action.category) ? [] : validatePresentationName(action.presentation.name))
                .set("presentationParticipantsErrors", validatePresentationParticipants(action.category, action.presentation.participants))
                .set("participantSearchText", "")
                .set("availableParticipants", getAvailableParticipants(state.participants, action.category, action.presentation.participants, ""))
                .toJS();
        case "EDIT_PRESENTATION":
            return Immutable.fromJS(state)
                .set("category", action.category)
                .set("presentation", action.presentation)
                .set("presentationNameErrors", isDuet(action.category) ? [] : validatePresentationName(action.presentation.name))
                .set("presentationParticipantsErrors", validatePresentationParticipants(action.category, action.presentation.participants))
                .set("participantSearchText", "")
                .set("availableParticipants", getAvailableParticipants(state.participants, action.category, action.presentation.participants, ""))
                .toJS();
        case "DELETE_PRESENTATION_PENDING":
            return Immutable.fromJS(state)
                .set("deletingPresentation", true)
                .set("deletingCategoryId", action.meta.category.id)
                .set("deletingPresentationId", action.meta.presentation.id)
                .set("deletingPresentationFailed", false)
                .set("deletingPresentationError", "")
                .toJS();
        case "DELETE_PRESENTATION_FULFILLED":
            categories = state.categories.map((c) =>
                c.id === state.deletingCategoryId
                    ? Immutable.fromJS(c)
                          .set(
                              "presentations",
                              c.presentations.filter((p) => p.id !== state.deletingPresentationId)
                          )
                          .toJS()
                    : c
            );
            return Immutable.fromJS(state)
                .set("deletingPresentation", false)
                .set("deletingCategoryId", -1)
                .set("deletingPresentationId", -1)
                .set("categories", categories)
                .set(
                    "application",
                    Immutable.fromJS(state.application)
                        .set("categoryCount", countUsedCategories(categories))
                        .set("presentationCount", countPresentations(categories))
                        .set("participantCount", countParticipants(categories))
                        .set("totalCost", calculateTotalCost(categories, state.contest))
                        .toJS()
                )
                .toJS();
        case "DELETE_PRESENTATION_REJECTED":
            return Immutable.fromJS(state)
                .set("deletingPresentation", false)
                .set("deletingCategoryId", -1)
                .set("deletingPresentationId", -1)
                .set("deletingPresentationFailed", true)
                .set("deletingPresentationError", action.payload.response.data.message)
                .toJS();
        case "SAVE_PRESENTATION_PENDING":
            return Immutable.fromJS(state).set("savingPresentation", true).set("savingPresentationFailed", false).set("savingPresentationError", "").toJS();
        case "SAVE_PRESENTATION_FULFILLED":
            categories = state.categories.map((c) =>
                c.id === state.category.id
                    ? Immutable.fromJS(c)
                          .set(
                              "presentations",
                              state.category.presentations.map((p) => (p.id === state.presentation.id ? action.payload.data : p))
                          )
                          .toJS()
                    : c
            );
            return Immutable.fromJS(state)
                .set("savingPresentation", false)
                .set("categories", categories)
                .set("category", {})
                .set("presentation", {})
                .set(
                    "application",
                    Immutable.fromJS(state.application)
                        .set("categoryCount", countUsedCategories(categories))
                        .set("presentationCount", countPresentations(categories))
                        .set("participantCount", countParticipants(categories))
                        .set("totalCost", calculateTotalCost(categories, state.contest))
                        .toJS()
                )
                .toJS();
        case "SAVE_PRESENTATION_REJECTED":
            return Immutable.fromJS(state).set("savingPresentation", false).set("savingPresentationFailed", true).set("savingPresentationError", action.payload.response.data.message).toJS();
        case "CANCEL_EDIT":
            return Immutable.fromJS(state).set("category", {}).set("presentation", {}).set("soloParticipants", []).toJS();
        case "UPDATE_PRESENTATION_NAME":
            return Immutable.fromJS(state)
                .set("presentation", Immutable.fromJS(state.presentation).set("name", action.value).toJS())
                .set("presentationNameErrors", validatePresentationName(action.value))
                .toJS();
        case "REMOVE_PARTICIPANT_FROM_PRESENTATION":
            participants = state.presentation.participants.filter((p) => p.id !== action.participant.id);
            return Immutable.fromJS(state)
                .set(
                    "presentation",
                    Immutable.fromJS(state.presentation)
                        .set("participants", participants)
                        .set("name", isDuet(state.category) ? generatePresentationName(participants) : state.presentation.name)
                        .toJS()
                )
                .set("presentationNameErrors", isDuet(state.category) ? [] : validatePresentationName(state.presentation.name))
                .set("presentationParticipantsErrors", validatePresentationParticipants(state.category, participants))
                .set("availableParticipants", getAvailableParticipants(state.participants, state.category, participants, state.participantSearchText))
                .toJS();
        case "ADD_PARTICIPANT_TO_PRESENTATION":
            participants = state.presentation.participants.concat(action.participant);
            return Immutable.fromJS(state)
                .set(
                    "presentation",
                    Immutable.fromJS(state.presentation)
                        .set("participants", participants)
                        .set("name", isDuet(state.category) ? generatePresentationName(participants) : state.presentation.name)
                        .toJS()
                )
                .set("presentationNameErrors", isDuet(state.category) ? [] : validatePresentationName(state.presentation.name))
                .set("presentationParticipantsErrors", validatePresentationParticipants(state.category, participants))
                .set("availableParticipants", getAvailableParticipants(state.participants, state.category, participants, state.participantSearchText))
                .toJS();
        case "REMOVE_PARTICIPANT_FROM_SOLO_CATEGORY":
            participants = state.soloParticipants.filter((p) => p.id !== action.participant.id);
            return Immutable.fromJS(state)
                .set("soloParticipants", participants)
                .set("availableParticipants", getAvailableParticipants(state.participants, state.category, participants, state.participantSearchText))
                .toJS();
        case "ADD_PARTICIPANT_TO_SOLO_CATEGORY":
            participants = state.soloParticipants.concat(action.participant);
            return Immutable.fromJS(state)
                .set("soloParticipants", participants)
                .set("availableParticipants", getAvailableParticipants(state.participants, state.category, participants, state.participantSearchText))
                .toJS();
        case "SAVE_SOLO_CATEGORY_PENDING":
            return Immutable.fromJS(state).set("savingPresentation", true).set("savingPresentationFailed", false).set("savingPresentationError", "").toJS();
        case "SAVE_SOLO_CATEGORY_FULFILLED":
            categories = state.categories.map((c) => (c.id === state.category.id ? Immutable.fromJS(c).set("presentations", action.payload.data).toJS() : c));
            return Immutable.fromJS(state)
                .set("savingPresentation", false)
                .set("category", {})
                .set("categories", categories)
                .set(
                    "application",
                    Immutable.fromJS(state.application)
                        .set("categoryCount", countUsedCategories(categories))
                        .set("presentationCount", countPresentations(categories))
                        .set("participantCount", countParticipants(categories))
                        .set("totalCost", calculateTotalCost(categories, state.contest))
                        .toJS()
                )

                .toJS();
        case "SAVE_SOLO_CATEGORY_REJECTED":
            return Immutable.fromJS(state).set("savingPresentation", false).set("savingPresentationFailed", true).set("savingPresentationError", action.payload.response.data.message).toJS();
        case "UPDATE_PARTICIPANT_SEARCH_TEXT":
            return Immutable.fromJS(state)
                .set("participantSearchText", action.value)
                .set(
                    "availableParticipants",
                    getAvailableParticipants(state.participants, state.category, isSolo(state.category) ? state.soloParticipants : state.presentation.participants, action.value)
                )
                .toJS();
        case "CLEAR_ERRORS":
            return Immutable.fromJS(state)
                .set("savingPresentationFailed", false)
                .set("savingPresentationError", "")
                .set("deletingPresentationFailed", false)
                .set("deletingPresentationError", "")
                .set("sendingApplicationFailed", false)
                .set("sendingApplicationError", "")
                .set("revertingApplicationFailed", false)
                .set("revertingApplicationError", "")
                .toJS();
        case "GET_APPLICATION_PAYMENTS_PENDING":
            return Immutable.fromJS(state).set("loadingPayments", true).set("loadingPaymentsFailed", false).set("loadingPaymentsError", "").set("payments", []).toJS();
        case "GET_APPLICATION_PAYMENTS_FULFILLED":
            return Immutable.fromJS(state)
                .set("loadingPayments", false)
                .set(
                    "payments",
                    action.payload.data.map((payment) => Immutable.fromJS(payment).set("amount", formatAmount(payment.amount)).toJS())
                )
                .set("totalCost", sumPayments(action.payload.data))
                .toJS();
        case "GET_APPLICATION_PAYMENTS_REJECTED":
            return Immutable.fromJS(state).set("loadingPayments", false).set("loadingPaymentsFailed", true).set("loadingPaymentsError", action.payload.response.data.message).toJS();
        default:
            return state;
    }
}

function isSolo(category) {
    return category.minPresentationSize === 1 && category.maxPresentationSize === 1;
}

function isDuet(category) {
    return category.minPresentationSize === 2 && category.maxPresentationSize === 2;
}

function generatePresentationName(participants) {
    var name = "";
    for (var i = 0; i < participants.length && i < 2; i++) {
        if (i > 0) {
            name += ", ";
        }
        name += participants[i].firstName;
        name += " ";
        name += participants[i].lastName;
    }
    return name;
}

function getAvailableParticipants(allParticipants, selectedCategory, selectedParticipants, searchText) {
    var unavailableParticipantIds = [];
    if (!isSolo(selectedCategory)) {
        selectedCategory.presentations.forEach((p1) => {
            p1.participants.forEach((p2) => {
                unavailableParticipantIds.push(p2.id);
            });
        });
    }
    selectedParticipants.forEach((p1) => {
        unavailableParticipantIds.push(p1.id);
    });
    var searchArray = searchText.toLowerCase().split(" ");
    return allParticipants.filter((participant) => {
        if (typeof selectedCategory.minParticipantBirthDate !== "undefined") {
            let minParticipantBirthDate = new Date(
                parseInt(selectedCategory.minParticipantBirthDate.substring(0, 4), 10),
                parseInt(selectedCategory.minParticipantBirthDate.substring(5, 7), 10) - 1,
                parseInt(selectedCategory.minParticipantBirthDate.substring(8, 10), 10)
            );
            let birthDate = new Date(
                parseInt(participant.birthDate.substring(0, 4), 10),
                parseInt(participant.birthDate.substring(5, 7), 10) - 1,
                parseInt(participant.birthDate.substring(8, 10), 10)
            );
            if (birthDate < minParticipantBirthDate) {
                return false;
            }
        }
        if (typeof selectedCategory.maxParticipantBirthDate !== "undefined") {
            let maxParticipantBirthDate = new Date(
                parseInt(selectedCategory.maxParticipantBirthDate.substring(0, 4), 10),
                parseInt(selectedCategory.maxParticipantBirthDate.substring(5, 7), 10) - 1,
                parseInt(selectedCategory.maxParticipantBirthDate.substring(8, 10), 10)
            );
            let birthDate = new Date(
                parseInt(participant.birthDate.substring(0, 4), 10),
                parseInt(participant.birthDate.substring(5, 7), 10) - 1,
                parseInt(participant.birthDate.substring(8, 10), 10)
            );
            if (birthDate > maxParticipantBirthDate) {
                return false;
            }
        }
        if (typeof selectedCategory.gender !== "undefined") {
            if (selectedCategory.gender === "MALE" && participant.gender !== "MALE") {
                return false;
            }
            if (selectedCategory.gender === "FEMALE" && participant.gender !== "FEMALE") {
                return false;
            }
        }
        if (unavailableParticipantIds.includes(participant.id)) {
            return false;
        }
        var participantName = participant.firstName.toLowerCase() + " " + participant.lastName.toLowerCase();
        var i = 0;
        searchArray.forEach((searchText) => {
            if (participantName.indexOf(searchText) > -1) {
                i++;
            }
        });
        if (i < searchArray.length) {
            return false;
        }
        return true;
    });
}

function validatePresentationName(value) {
    var errors = [];
    if (!value.match(/^[-0-9A-Za-zĄąĆćĘęŁłŃńÓóŚśŻżŹź\s]*,?[-0-9A-Za-zĄąĆćĘęŁłŃńÓóŚśŻżŹź\s]*$/)) {
        errors.push("Nazwa może składać się wyłącznie z liter, cyfr, myślnika i spacji");
    }
    if (value.length > 2 && value.match(/^\s+$/)) {
        errors.push("Nazwa nie może składać się wyłącznie ze spacji");
    }
    if (value.length < 3) {
        errors.push("Nazwa nie może być krótsza niż 3 znaki");
    }
    if (value.length > 60) {
        errors.push("Nazwa nie może być dłuższa niż 60 znaków");
    }
    return errors;
}

function validatePresentationParticipants(category, participants) {
    var errors = [];
    if (participants.length < category.minPresentationSize) {
        errors.push("Ilość tancerzy przypisanych do prezentacji musi wynosić co najmniej " + category.minPresentationSize);
    }
    if (participants.length > category.maxPresentationSize) {
        errors.push("Ilość tancerzy przypisanych do prezentacji musi wynosić co najwyżej " + category.maxPresentationSize);
    }
    return errors;
}

function countUsedCategories(categories) {
    return categories.filter((category) => category.presentations.length > 0).length;
}

function countPresentations(categories) {
    return categories.map((category) => category.presentations.length).reduce((a, b) => a + b, 0);
}

function countParticipants(categories) {
    var participants = [];
    categories.forEach((category) => {
        category.presentations.forEach((presentation) => {
            presentation.participants.forEach((participant) => {
                if (!participants.includes(participant.id)) {
                    participants.push(participant.id);
                }
            });
        });
    });
    return participants.length;
}

function calculateTotalCost(categories, contest) {
    var participantBaseCost = Math.round(contest.participantBaseCost * 100);
    var participantPresentationCost = Math.round(contest.participantPresentationCost * 100);
    var totalCost = 0;
    if (contest.paymentsEnabled && contest.paymentType !== "PER_PARTICIPANT_IN_CATEGORY") {
        var participants = {};
        categories.forEach((category) => {
            category.presentations.forEach((presentation) => {
                presentation.participants.forEach((participant) => {
                    if (typeof participants[participant.id] === "undefined") {
                        participants[participant.id] = 1;
                    } else {
                        participants[participant.id]++;
                    }
                });
            });
            if (category.presentationCost !== "undefined") {
                totalCost += Math.round(category.presentationCost * 100) * category.presentations.length;
            }
        });
        Object.keys(participants).forEach((participant) => {
            totalCost += participantBaseCost + participants[participant] * participantPresentationCost;
        });
    }
    if (contest.paymentsEnabled && contest.paymentType === "PER_PARTICIPANT_IN_CATEGORY") {
        categories.forEach((category) => {
            category.presentations.forEach((presentation) => {
                totalCost += Math.round(category.participantCost * 100) * presentation.participants.length;
            });
        });
    }
    return formatAmount(totalCost / 100);
}

function sumPayments(payments) {
    var totalCost = 0;
    payments.forEach((payment) => {
        totalCost += Math.round(payment.amount * 100);
    });
    return formatAmount(totalCost / 100);
}

function formatAmount(amount) {
    var formatter = new Intl.NumberFormat("pl-PL", {
        style: "currency",
        currency: "PLN",
        minimumFractionDigits: 2,
    });
    return formatter.format(amount);
}



// WEBPACK FOOTER //
// ./src/reducers/application.js